import axios from '@octagon/axios';
import { apiInstanceAuth } from './apiInstance';
import type { AuthenticationRequest } from '../models/AuthenticationRequest';

export const getEncompassToken = async (authenticationRequest: AuthenticationRequest): Promise<any> => {
  try {
    const response = await apiInstanceAuth.post('/get-token', authenticationRequest, {
      headers: {
        'Content-Type': 'application/json',
      }
    });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.log('Axios error:', error);
      throw new Error('Error fetching data');
    } else {
      console.log('Non-axios error:', error);
      throw error;
    }
  }
};
